/**
 * InfoTip —— 字段帮助气泡（docs/ui_page §4.5 / ui_page_head_detail §5.4）
 * 封装 TeachingPopover，触发器为 QuestionCircle 圆形 subtle 按钮，
 * 与顶栏 PageBreadcrumb 帮助按钮同款交互。用于只读字段 / 统计卡片等
 * "只读 + 专业"字段的 label 右侧帮助入口。
 */
import type { ReactNode } from 'react'
import {
  makeStyles,
  tokens,
  Button,
  TeachingPopover,
  TeachingPopoverBody,
  TeachingPopoverSurface,
  TeachingPopoverTitle,
  TeachingPopoverTrigger,
} from '@fluentui/react-components'
import { QuestionCircle20Regular } from '@fluentui/react-icons'

const useStyles = makeStyles({
  trigger: {
    width: '20px',
    height: '20px',
    minWidth: '20px',
    padding: '0',
    marginLeft: '4px',
    color: tokens.colorNeutralForeground3,
    verticalAlign: 'middle',
    borderRadius: tokens.borderRadiusCircular,
    ':hover': {
      color: tokens.colorBrandForeground1,
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
    ':active': {
      color: tokens.colorBrandForeground1,
    },
  },
  surface: {
    maxWidth: '340px',
  },
  body: {
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground2,
  },
})

export function InfoTip(props: {
  title?: string
  content: ReactNode
  ariaLabel?: string
}) {
  const styles = useStyles()
  return (
    <TeachingPopover>
      <TeachingPopoverTrigger>
        <Button
          type="button"
          icon={<QuestionCircle20Regular />}
          appearance="transparent"
          size="small"
          className={styles.trigger}
          aria-label={props.ariaLabel ?? '查看说明'}
          title="说明"
          onMouseDown={(e) => e.preventDefault()}
        />
      </TeachingPopoverTrigger>
      <TeachingPopoverSurface className={styles.surface}>
        {props.title && <TeachingPopoverTitle>{props.title}</TeachingPopoverTitle>}
        <TeachingPopoverBody className={styles.body}>{props.content}</TeachingPopoverBody>
      </TeachingPopoverSurface>
    </TeachingPopover>
  )
}
